module.exports = __webpack_public_path__ + "static/media/note-remove.9f132c72.svg";